import React from 'react'
import './skills.css'
import {BsPatchCheckFill} from 'react-icons/bs'

// Ordered by current stack priority: Java -> Spring Boot -> React -> Next.js -> TypeScript -> PostgreSQL
const skillGroups = [
  {
    title: 'Backend Development',
    skills: ['Java', 'Spring Boot', 'REST APIs', 'Hibernate / JPA', 'PostgreSQL', 'Maven']
  },
  {
    title: 'Frontend Development',
    skills: ['React', 'Next.js', 'TypeScript', 'JavaScript', 'HTML', 'CSS']
  }
]

const Skills = () => {
  return (
    <section id='skills'>
      <h5>The Skills I Have</h5>
      <h2>My Skills</h2>

      <div className="container experience_container">
        {skillGroups.map(({title, skills}) => (
          <div key={title}>
            <h3>{title}</h3>
            <div className="experience_content">
              {skills.map(skill => (
                <article key={skill} className='experience_details'>
                  <BsPatchCheckFill className='experience_details-icon'/>
                  <div>
                    <h4>{skill}</h4>
                  </div>
                </article>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default Skills
